import { IDVGItemDTO, IGenericDTO } from "coreframetypings/dto";
import { IReadOnlyPrinterStatic } from '#/DefaultViewExtensionInterfaces';
import RADApplication from '@/Management/RADApplication';
import SimpleLinkBuilder from '@/Builder/SimpleLinkBuilder';
import { staticImplements } from '@/Components/@Decorator/StaticImplementsDecorator';
import * as DownloadHelper from '@/Utility/DownloadHelper';
import Utilities from '@/Utility/Utilities';

@staticImplements<IReadOnlyPrinterStatic>()
export default class EmbeddedMediumLinkPrinter {

    public static print(item: IDVGItemDTO, value: string, row: IGenericDTO): HTMLElement {
        return new SimpleLinkBuilder()
            .withCaption(value)
            .withOnClick(() => {
                DownloadHelper.openDownloadDialogFromApplicationAsync(`${RADApplication.getInstance().radEnvironmentMediumHandler}?PDOID=${row.pdoId}&AttributeName=${item.name}&WithoutLock=true`);
            })
            .buildAndGetElement();
    }

    public static isRelevant(item: IDVGItemDTO, value: string, row: IGenericDTO): boolean {
        if (Utilities.isNullOrUndefinedOrBlank(value))
            return false;

        return item.uiGenerator.startsWith('EmbeddedMediumBox');
    }

    public static createToolTip(item: IDVGItemDTO, value: string, row: IGenericDTO): string {
        return value;
    }
}